// extracted by mini-css-extract-plugin
module.exports = {"b2b-offer":"B2BOffer_b2b-offer__AGJZf","actions":"B2BOffer_actions__cpeYH","cta":"B2BOffer_cta__QL_TQ","mail-link":"B2BOffer_mail-link__Tc_xh"};